// src/components/layout/DashboardShell.tsx
import type { ReactNode } from 'react';
import { Sidebar, BottomNav } from '@/components/layout/Sidebar';
import { SessionExpiryBanner } from '@/components/ui/SessionExpiryBanner';
import { MissedAlertsPanel } from '@/components/ui/MissedAlertsPanel';

export default function DashboardShell({ children }: { children: ReactNode }) {
  return (
    <div className="app-shell">
      <Sidebar />

      <div className="app-main app-content-mobile-pad">
        <SessionExpiryBanner />
        {children}
      </div>

      <BottomNav />
      <MissedAlertsPanel />
    </div>
  );
}
